import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFlipHorizontalCircle12 from './IconFlipHorizontalCircle12';
import IconFlipHorizontalCircle16 from './IconFlipHorizontalCircle16';
import IconFlipHorizontalCircle20 from './IconFlipHorizontalCircle20';
import IconFlipHorizontalCircle24 from './IconFlipHorizontalCircle24';
import IconFlipHorizontalCircle32 from './IconFlipHorizontalCircle32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFlipHorizontalCircle = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFlipHorizontalCircle12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFlipHorizontalCircle16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFlipHorizontalCircle20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFlipHorizontalCircle24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFlipHorizontalCircle32 {...props} />}
        </span>
    );
};
IconFlipHorizontalCircle.displayName = 'FondueIconFlipHorizontalCircle';

export default memo(IconFlipHorizontalCircle);
